import React from "react";
import LegalbirdLoader from "../../../components/ContentLoader/LegalbirdLoader";
import LayoutAuthenticated from "@/src/containers/Layouts/LayoutAuthenticated";

export default function LegalbirdAuthenticatedLoaderPage() {
  return (
    <LayoutAuthenticated>
      <LegalbirdLoader />
    </LayoutAuthenticated>
  );
}
